export async function printViewportMap(mapRequest) {
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(mapRequest)
    };
    return fetch('/api/maps/print/map', options);
}
